<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="messages.length"
        badge-classes="bg-success"
        class="text-body"
        icon="MailIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t('Messages') }}
        </h4>
        <b-badge
          pill
          variant="success"
        >
          {{ messages.length }} {{ $t('new') }}
        </b-badge>
      </div>
    </li>

    <!-- Messages -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >

      <b-link
        v-for="(message,index) in messages"
        :key="index"
        class="d-flex"
        @click="readMessage(message)"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="message.variant"
            >
              <feather-icon :icon="message.icon" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ message.title }}
            </span>
          </p>
          <small class="notification-text">{{ formatDate(message.createDate) }}

          </small>

        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="allMessages"
      >{{ $t('Show all messages') }}</b-button>
    </li>

  </b-nav-item-dropdown>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    userLevel: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      userData: null,
      messages: [],
      readItem: null,
    }
  },
  mounted() {
    this.$root.$on('refresh_messages', () => {
      this.getMessages()
    })
  },
  beforeDestroy() {
    this.$root.$off('refresh_messages')
  },
  created() {
    this.getMessages()
  },
  methods: {
    allMessages() {
      this.$router.push({ name: 'messages', params: { } })
    },
    formatDate(date) {
      return dayjs(date).fromNow()
    },
    readMessage(message) {
      // this.readItem = message
      this.$root.$emit('read_message', message)

      // this.$nextTick(() => {
      //   this.$bvModal.show('modal-message')
      // })
    },
    getMessages() {
      useJwt.axiosIns.get('message/new')
        .then(response => {
          if (response.data) {
            this.messages = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
  setup() {
    /* eslint-disable global-require */

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>
